module.exports = __webpack_public_path__ + "static/media/micro373.ff0fa820.jpg";